<template>
  <div class="p-2 p-sm-3 fq-Block_Wrapper">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex flex-column pr-2">
        <div class="fq-Block_Title text-dark mb-1">{{ title }}</div>
        <p class="fq-Block_Text text-muted mb-2">{{ description }}</p>
        <div>
          <ActionButton class="bg-white" :href="link">{{ linkText }}</ActionButton>
        </div>
      </div>
      <div class="text-primary my-n4">
        <Logistics class="svg-192" />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "./ActionButton.vue";
import Logistics from "../../../assets/images/static/corona/logistics.svg";

export default {
  name: "IconTeaser",
  components: {
    Logistics,
    ActionButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    linkText: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.fq-Block_Wrapper {
  background: $gray-200;
  border-radius: $border-radius;
}

.fq-Block_Title {
  font-family: $headings-font-family;
  font-weight: $font-weight-bold;
  line-height: $headings-line-height;
  font-size: $h5-font-size;

  @media (min-width: $screen-sm-min) {
    font-size: $h4-font-size;
  }
}

.fq-Block_Text {
  max-width: 40ch;
}
</style>
